'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var DataPickerArrow = function DataPickerArrow(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 8 13' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Data-picker-arrow'
      ),
      _react2.default.createElement('path', { d: 'M7.954 6.248L.995 12.999 0 12.037l5.928-5.751L.014.957 1.008 0l5.911 5.325 1.035.923', fill: 'currentColor', fillRule: 'evenodd'
      })
    )
  );
};
/*eslint-enable */

exports.default = DataPickerArrow;
//# sourceMappingURL=DataPickerArrow.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/DataPickerArrow.js